import { Navigate } from "react-router";
import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import { getEnvironmentVariable, isDev } from "../global/environmentVariables";
import PlayerRankings from "../pages/rankings/PlayerRankings";
import Rankings from "../pages/rankings/Rankings";
import TeamRankings from "../pages/rankings/TeamRankings";
import TruncatedRankings from "../pages/rankings/TruncatedRankings";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import NotFound from "../pages/utility/NotFound";
import Leaderboards from "../pages/leaderboards/Leaderboards";

export const rankingsRoutes = (
  authContext,
  itemsMiddle,
  setItemsMiddle,
  eventObject,
  setEventObject
) => {
  const forceLoginParam = findGetParameter("forceLogin");
  const LEADERBOARDS =
    getEnvironmentVariable("LEADERBOARDS") === "true" ||
    getEnvironmentVariable("COMPANY_FLAG") === "gw" ||
    (isDev() && localStorage?.getItem("leaderboardRedesign") === "true");

  if (getEnvironmentVariable("HIDE_RANKINGS") === "true") {
    return [];
  }

  const leaderboardChildren = [
    { path: "/leaderboards/", element: <Leaderboards /> },
    {
      path: "spain/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="7oVuO1Cse6" />
    },
    {
      path: "spain/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="7oVuO1Cse6" />
    },
    {
      path: "spain/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="7oVuO1Cse6" />
    },

    // aus routes // regionId="8caheRYkYV"
    {
      path: "aus/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="8caheRYkYV" />
    },
    {
      path: "aus/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="8caheRYkYV" />
    },
    {
      path: "aus/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="8caheRYkYV" />
    },

    // germany routes // regionId="3ASOJvOnsN"
    {
      path: "germany/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="3ASOJvOnsN" />
    },
    {
      path: "germany/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="3ASOJvOnsN" />
    },
    {
      path: "germany/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="3ASOJvOnsN" />
    },

    // new_zealand routes // regionId="VqdvqrCb9o"
    {
      path: "new_zealand/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="VqdvqrCb9o" />
    },
    {
      path: "new_zealand/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="VqdvqrCb9o" />
    },
    {
      path: "new_zealand/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="VqdvqrCb9o" />
    },

    // sweden routes // regionId="3DGHTEfjRp"
    {
      path: "sweden/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="3DGHTEfjRp" />
    },
    {
      path: "sweden/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="3DGHTEfjRp" />
    },
    {
      path: "sweden/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="3DGHTEfjRp" />
    },

    // france routes // regionId="eDAe4MN5bU"
    {
      path: "france/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="eDAe4MN5bU" />
    },
    {
      path: "france/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="eDAe4MN5bU" />
    },
    {
      path: "france/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="eDAe4MN5bU" />
    },

    { path: ":leagueId", element: <Leaderboards activeTab="truncated" /> },
    {
      path: ":leagueId/players",
      element: <Leaderboards activeTab="players" />
    },
    { path: ":leagueId/teams", element: <Leaderboards activeTab="players" /> },

    { path: "players", element: <Leaderboards activeTab="players" /> },
    { path: "teams", element: <Leaderboards activeTab="teams" /> },

    { path: "*", element: <NotFound /> }
  ];

  const rankingsChildren = [
    { path: "/rankings/", element: <Leaderboards /> },

    // spain routes // regionId="7oVuO1Cse6"
    {
      path: "spain/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="7oVuO1Cse6" />
    },
    {
      path: "spain/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="7oVuO1Cse6" />
    },
    {
      path: "spain/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="7oVuO1Cse6" />
    },

    // aus routes // regionId="8caheRYkYV"
    {
      path: "aus/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="8caheRYkYV" />
    },
    {
      path: "aus/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="8caheRYkYV" />
    },
    {
      path: "aus/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="8caheRYkYV" />
    },

    // germany routes // regionId="3ASOJvOnsN"
    {
      path: "germany/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="3ASOJvOnsN" />
    },
    {
      path: "germany/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="3ASOJvOnsN" />
    },
    {
      path: "germany/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="3ASOJvOnsN" />
    },

    // new_zealand routes // regionId="VqdvqrCb9o"
    {
      path: "new_zealand/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="VqdvqrCb9o" />
    },
    {
      path: "new_zealand/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="VqdvqrCb9o" />
    },
    {
      path: "new_zealand/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="VqdvqrCb9o" />
    },

    // sweden routes // regionId="3DGHTEfjRp"
    {
      path: "sweden/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="3DGHTEfjRp" />
    },
    {
      path: "sweden/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="3DGHTEfjRp" />
    },
    {
      path: "sweden/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="3DGHTEfjRp" />
    },

    // france routes // regionId="eDAe4MN5bU"
    {
      path: "france/:leagueId",
      element: <Leaderboards activeTab="truncated" regionId="eDAe4MN5bU" />
    },
    {
      path: "france/:leagueId/players",
      element: <Leaderboards activeTab="players" regionId="eDAe4MN5bU" />
    },
    {
      path: "france/:leagueId/teams",
      element: <Leaderboards activeTab="teams" regionId="eDAe4MN5bU" />
    },

    { path: ":leagueId", element: <Leaderboards activeTab="truncated" /> },
    {
      path: ":leagueId/players",
      element: <Leaderboards activeTab="players" />
    },
    { path: ":leagueId/teams", element: <Leaderboards activeTab="teams" /> },

    { path: "players", element: <Leaderboards activeTab="players" /> },
    { path: "teams", element: <Leaderboards activeTab="teams" /> },

    { path: "*", element: <NotFound /> }
  ];

  return [
    {
      path: "rankings",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: rankingsChildren
    },
    {
      path: "leaderboards",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : !LEADERBOARDS &&
          authContext?.authState?.identity?.isAdmin !== true &&
          !authContext?.authState?.identity?.adminGameSystems?.length ? (
          <Navigate to="/access-denied" />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: leaderboardChildren
    }
  ];
};

export const rootRankingsRoutes = () => {
  if (getEnvironmentVariable("HIDE_RANKINGS") === "true") {
    return [];
  }

  let _routes = [
    {
      path: "bcprankings",
      element: <Rankings />
    }, // route from historic routes
    {
      path: "bcpplayers/",
      element: <PlayerRankings />
    }, // route from historic routes
    {
      path: "bcpteams/",
      element: <TeamRankings />
    }, // route from historic routes

    {
      path: "bcptruncated/:leagueId",
      element: <TruncatedRankings />
    } // route from historic routes
  ];

  if (getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")) {
    _routes.push(
      {
        path: "itctruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")}
          />
        )
      },
      {
        path: "spain-itctruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")}
            regionId="7oVuO1Cse6"
          />
        )
      },
      {
        path: "newzealand-itctruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")}
            regionId="VqdvqrCb9o"
          />
        )
      },
      {
        path: "sweden-itctruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")}
            regionId="3DGHTEfjRp"
          />
        )
      },
      {
        path: "germ-itctruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")}
            regionId="3ASOJvOnsN"
          />
        )
      },
      {
        path: "france-itctruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")}
            regionId="eDAe4MN5bU"
          />
        )
      },
      {
        path: "aus-itctruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")}
            regionId="8caheRYkYV"
          />
        )
      }
    );
  }

  if (getEnvironmentVariable("DEFAULT_ITC_40K_HOBBY_LEAGUE_ID")) {
    _routes.push(
      {
        path: "itchobby",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_HOBBY_LEAGUE_ID")}
          />
        )
      },
      {
        path: "aus-itchobby",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_HOBBY_LEAGUE_ID")}
            regionId="8caheRYkYV"
          />
        )
      }
    );
  }

  if (getEnvironmentVariable("DEFAULT_ITC_AOS_LEAGUE_ID")) {
    _routes.push(
      {
        path: "aostruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_AOS_LEAGUE_ID")}
          />
        )
      },
      {
        path: "aus-aostruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_AOS_LEAGUE_ID")}
            regionId="8caheRYkYV"
          />
        )
      }
    );
  }

  if (getEnvironmentVariable("DEFAULT_ITC_AOS_HOBBY_LEAGUE_ID")) {
    _routes.push(
      {
        path: "aoshobby",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_AOS_HOBBY_LEAGUE_ID")}
          />
        )
      },
      {
        path: "aus-aoshobby",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_AOS_HOBBY_LEAGUE_ID")}
            regionId="8caheRYkYV"
          />
        )
      }
    );
  }

  if (getEnvironmentVariable("DEFAULT_ITC_SHADESPIRE_LEAGUE_ID")) {
    _routes.push(
      {
        path: "shadespiretruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable(
              "DEFAULT_ITC_SHADESPIRE_LEAGUE_ID"
            )}
          />
        )
      },
      {
        path: "aus-shadespiretruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable(
              "DEFAULT_ITC_SHADESPIRE_LEAGUE_ID"
            )}
            regionId="8caheRYkYV"
          />
        )
      }
    );
  }

  if (getEnvironmentVariable("DEFAULT_ITC_KILL_TEAM_LEAGUE_ID")) {
    _routes.push(
      {
        path: "killteamtruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_KILL_TEAM_LEAGUE_ID")}
          />
        )
      },
      {
        path: "aus-killteamtruncated",
        element: (
          <TruncatedRankings
            leagueId={getEnvironmentVariable("DEFAULT_ITC_KILL_TEAM_LEAGUE_ID")}
            regionId="8caheRYkYV"
          />
        )
      }
    );
  }

  return _routes;
};
